module.exports = __webpack_public_path__ + "img/mon_64.4098a55d.png";